export default function DeleteModal(
    { confirmFN, hideModal, headerText, contentText, confirmButtonText }: 
    { confirmFN: () => void; hideModal: () => void, headerText: string, contentText: string, confirmButtonText:string }
  ) {
    return (
        <div className="app-modal">
            <div className="delete-project card" onClick={(e) => e.stopPropagation()}>
                <div className="card-title">
                    <h5>{headerText}</h5>
                </div>

                <div className="card-content">
                    <p>{contentText}</p>
                </div>

                <div className="card-footer m-2">
                    <button className="btn white black-text" onClick={hideModal}>
                        Cancel
                    </button>
                    <button className="btn red lighten-2" onClick={confirmFN}>
                        {confirmButtonText}
                    </button>
                </div>
            </div>
        </div>
    );
}
